<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs4 v-for="(stat, index) in stats" :key="index">
        <v-card class="text-xs-center" height="100%" :to="stat.link">
          <v-card-text>
            <div class="display-1 mb-2">
              <b v-if="!isLoading">{{ stat.count }}</b>
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
                v-if="isLoading"
              ></v-progress-circular>
            </div>
            {{ stat.title }}
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-divider class="mt-4"></v-divider>
    <DateFilter @date:changed="refreshAnalytics" class="mt-3" />
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <v-card>
          <v-card-title
            class="subheading font-weight-bold px-4"
          >Interventions History</v-card-title>
          <!-- <v-divider></v-divider> -->
          <v-container class="px-4 pt-0">
            <v-layout row wrap v-show="!analyticsLoading">
              <v-flex xs12>
                <BarChart v-if="stateAnalytics !== null" :values="stateAnalytics.history.values" :labels="stateAnalytics.history.labels" :height="150" />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center class="pt-2 pb-5" v-show="analyticsLoading">
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
              ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">Interventions Overview by Locations</v-card-title>
          <!-- <v-divider></v-divider> -->
          <v-container class="px-4 pt-0">
            <v-layout row wrap v-show="!analyticsLoading">
              <v-flex xs12>
                <PieChart v-if="stateAnalytics !== null" :values="stateAnalytics.overview.values" :labels="stateAnalytics.overview.labels" :height="150" />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center class="pt-2 pb-5" v-show="analyticsLoading">
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
              ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import '@/plugins/google-maps'

import { AID_FETCH } from '@/store/actions/aid'
import { USER_FETCH } from '@/store/actions/user'
import { LOCATION_FETCH } from '@/store/actions/location'
import { EVENT_FETCH } from '@/store/actions/event'

import BarChart from '@/components/Charts/BarChart.vue'
import PieChart from '@/components/Charts/PieChart.vue'
import DateFilter from '@/components/Filters/DateFilter.vue'
import { setFormData } from '@/utils/http'
import { refineAnalytics } from '@/utils/analytics'

export default {
  name: 'AdminDashboard',
  components: {
    BarChart,
    PieChart,
    DateFilter
  },
  created () {
		this.isLoading = true
		
		Promise.all([
      this.$store.dispatch(AID_FETCH),
      this.$store.dispatch(USER_FETCH, { isAdmin: false }),
      this.$store.dispatch(LOCATION_FETCH),
      this.$store.dispatch(EVENT_FETCH)
    ]).finally(() => {
      this.isLoading = false
    })
  },
  data () {
    return {
      isLoading: false,
      analyticsLoading: false,
      stateAnalytics: null
    }
  },
  computed: {
		stats () {
			const aidsInState = this.$store.getters.aidsByField('state_id', this.currentUser.parent_id).length
			const eventsInState = this.$store.getters.eventsByField('state_id', this.currentUser.parent_id).length
			const locationsInState = this.$store.getters.locationsByField('state_id', this.currentUser.parent_id).length
			const staffInState = this.$store.getters.agentsByParent(this.currentUser.parent_id).length
			const stats = [
				{ title: 'Events', count: eventsInState, link: '/events' },
				{ title: 'Interventions Recorded', count: aidsInState, link: '/aids' },
        { title: 'Locations', count: locationsInState, link: '/locations' },
        { title: 'SEMA Staff', count: staffInState, link: '/users/agents/state' }
			]
			return stats
		},
    ...mapGetters(['currentUser'])
  },
  methods: {
    fetchStateHeadAnalytics (from, to, period) {
      this.analyticsLoading = true
      this.stateAnalytics = null
      const params = setFormData({
        state_id: this.currentUser.parent_id,
        from_timestamp: from,
        to_timestamp: to,
        period: period
      })
      this.$http.post('aid/analytics_by_state', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            this.analyticsLoading = false
            // State Analytics
            this.stateAnalytics = refineAnalytics('state', response.data)
          }
        })
    },
    refreshAnalytics (payload) {
      this.fetchStateHeadAnalytics(payload.from, payload.to, payload.period)
    }
  }
}
</script>
